import api from '@pray/shared/utils/api';

export async function triggerContentTranslation({
  artistId = null,
  contentId = null,
  locale = null,
  audioOnly = false,
  matchDuration = false,
  creditConfirmationId = null,
}) {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentId) throw Error('Content ID is required');
  if (!locale) throw Error('Locale is required');

  const data = {};
  if (audioOnly) data.audio_only = true;
  if (matchDuration) data.match_duration = true;
  if (creditConfirmationId) data.credit_confirmation_id = creditConfirmationId;

  const url = `/web/studio/artists/${artistId}/content/${contentId}/locales/${locale}`;
  const response = await api.executePostRequest(url, data);

  return response.data.data;
}
